// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7s_AL","clinicsSelect":"styles_clinicsSelect__1A7kj"};